<template>
  <div>
    <el-container style="text-align: center;">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px"
               style="margin: 50px auto;text-align: left;">
        <el-form-item label="购买版本:" prop="title">
          <el-select v-model="form.id" placeholder="请选择购买版本" @change="selectVersion">
            <el-option :label="item.title" :value="item.id" v-for="(item, index) in version" :index="'1-'+ index"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购买时长:" prop="month">
          <el-input-number placeHolder="请输入购买时长" v-model="form.month" controls-position="right" @change="handleChange"
                           :min="1"></el-input-number>
          月
        </el-form-item>
        <el-form-item label="支付方式:" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio-button label="微信"></el-radio-button>
            <el-radio-button label="支付宝"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="支付金额:">
          <b style="color: crimson;">{{ form.price }}</b>元
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">购买</el-button>
        </el-form-item>
      </el-form>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      version: [],
      baseid: '',
      versionPrice: '',
      out_trade_no: '',
      timer: '',
      form: {
        id: '',
        month: '1',
        type: '微信',
        price: ''
      },
      rules: {
        title: [{required: true, message: '请选择版本', trigger: 'blur'}],
        month: [{required: true, message: '请输入购买时长', trigger: 'change'}],
        type: [{required: true, message: '请选择支付方式', trigger: 'change'}]
      }
    };
  },
  mounted: function () {
    this.getVersion();
  },
  methods: {
    selectVersion(val) {
      var obj = {};
      obj = this.version.find(function (item) {
        return item.id === val;
      });
      this.versionPrice = obj.price;
      this.form.price = this.form.month * this.versionPrice;
    },
    getVersion() {
      this.postRequest("/userVersion/getVersion", {}).then(resp => {
        if (resp && resp.status == 200) {
          var data = resp.data;
          this.version = data;
          for (var i = 0; i < data.length; i++) {
            if (this.$route.query.type == i) {
              this.form.id = data[i].id;
              this.versionPrice = data[i].price;
              this.form.price = this.form.month * data[i].price;
              return;
            } else {
              this.form.id = data[0].id;
              this.versionPrice = data[0].price;
              this.form.price = this.form.month * data[0].price;
            }
          }
        }
      })
    },
    onSubmit() {
      this.out_trade_no = this.formatDateTimeValue();
      if (this.form.type == "微信") {
        var src = "/apis/weixin/weixinPay?baseid=" + this.form.id + "&month=" + this.form.month + "&type=" + this.form.type + "&out_trade_no=" + this.out_trade_no;
        this.$alert('<table style="width:100%;font-size:16px;height:400px;margin-top:30px;"><tr><td align="right">订单号：</td><td><b id="payOrderNum" style="color:red">' + this.out_trade_no + '</b></td></tr><tr><td align="right">支付金额：</td><td><b id="payMoney" style="color:red">' + this.form.price + '</b></td></tr><tr><td colspan="2" align="center"><img src="' + src + '" id="payCode"></img></td></tr></table>', '微信扫码支付', {
          dangerouslyUseHTMLString: true
        }).catch(() => {
        });
        this.timer = setInterval(this.checkPayStatus, 5000);
      } else {
        window.open("/apis/zfb/alipay?baseid=" + this.form.id + "&type=" + this.form.type + "&month=" + this.form.month + "&out_trade_no=" + this.out_trade_no, '_blank')
      }
    },
    handleChange(value) {
      this.form.price = this.form.month * this.versionPrice;
    },
    checkPayStatus() {
      this.postRequest("/weixin/checkStatus", {out_trade_no: this.out_trade_no}).then(resp => {
        if (resp && resp.status == 200) {
          var data = resp.data;
          if (data == 1) {
            clearInterval(this.timer);
            this.$message({
              message: '充值成功',
              type: 'success'
            });
            window.location.reload();
          }
        }
      })
    },
    formatDateTimeValue() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return year + "" + month + "" + day + "" + hours + "" + minutes + "" + seconds;
    }
  }
};
</script>
<style>
.el-dialog__body {
  padding-top: 0px;
  padding-bottom: 0px;
}

.slide-fade-enter-active {
  transition: all .8s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserRechargePage.vue